import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActsKC2AnalyticsBySeasonsGql } from '../../workOrderQueries';

interface IUseActsKC2AnalyticsBySeasons {
    workOrderId: number;
    workOrderRootObjectId?: number;
    seasonYear?: number;
    withEffect?: boolean;
}

const requestId = 'uerActsKC2AnalyticsBySeasons';

export const useActsKC2AnalyticsBySeasons = (props: IUseActsKC2AnalyticsBySeasons) => {
    const { workOrderId, workOrderRootObjectId, seasonYear, withEffect } = props;

    const [uerActsKC2AnalyticsBySeasonsReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({ workOrderId, workOrderRootObjectId, seasonYear }),
        [seasonYear, workOrderId, workOrderRootObjectId],
    );

    const [uerActsKC2AnalyticsBySeasonsData, uerActsKC2AnalyticsBySeasonsStatus] = useRequest({
        requestId,
        query: uerActsKC2AnalyticsBySeasonsGql,
        variables,
        withEffect,
    });

    useEffect(() => {
        uerActsKC2AnalyticsBySeasonsReset(undefined);
    }, [uerActsKC2AnalyticsBySeasonsReset]);

    return {
        uerActsKC2AnalyticsBySeasonsData,
        uerActsKC2AnalyticsBySeasonsStatus,
    };
};
